<template>
  <ValidationProvider v-slot="{ errors }"
                      :name="name"
                      :rules="rules"
                      tag="div"
  >
    <AGCLabel v-if="label" :required="required" :id="id">
      <slot>{{ label }}</slot>
      <template v-slot:subLabel>
        <slot name="subLabel">
          <span>{{ subLabel }}</span>
        </slot>
      </template>
    </AGCLabel>
    <b-form-group :invalid-feedback="errors[0]">
      <b-form-textarea v-model="inputVal"
                       :id="id"
                       :state="state(errors)"
                       :placeholder="placeholder"
                       :required="required"
                       :disabled="disabled"
      ></b-form-textarea>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import {
  BFormGroup,
  BFormTextarea,
} from 'bootstrap-vue';
import agcFormElementMixin from '@/mixins/agc-form-element';
import AGCLabel from '@/components/form/AGCLabel.vue';

export default {
  components: {
    BFormGroup,
    BFormTextarea,
    AGCLabel,
  },
  mixins: [agcFormElementMixin],
};
</script>
